$(document).ready(function() {
    // 1. RUN ON LOAD: Check radio based on URL
    function checkSortRadioFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.get('sort_by'); // Gets 'price-desc' from 'sort_by=price-desc'

        if (sortBy) {
            $(`input[name="sort_by"][value="sort_by=${sortBy}"]`).prop('checked', true);
        }
    }

    checkSortRadioFromUrl();

    $(document).on('click', '.js-apply-filter', function(e) {
        e.preventDefault();
        
        // 1. Get the current URL information
        const baseUrl = window.location.pathname; // e.g., "/search/" or "/catalogue/"
        const currentParams = new URLSearchParams(window.location.search);
        
        // 2. Clear old filters/sorts to start fresh, but KEEP the search query 'q'
        // We create a new params object and only carry over 'q' if it exists
        let newParams = new URLSearchParams();
        if (currentParams.has('q')) {
            newParams.set('q', currentParams.get('q'));
        }
    
        // 3. HANDLE BRAND FILTERS
        $('.accordItem[data-filter="brands"] input[type="checkbox"]:checked').each(function() {
            let brandName = $(this).closest('li').find('label span').text().trim();
            let encodedBrand = encodeURIComponent(brandName);
            
            // Use .append because you might have multiple selected_facets
            newParams.append("selected_facets", "attrs.brand:" + encodedBrand);
        });
    
        // 4. HANDLE SORTING
        let selectedSort = $('input[name="sort_by"]:checked').val();
        if (selectedSort) {
            // Split "sort_by=title-asc" and take the second part "title-asc"
            let sortActualValue = selectedSort.split('=')[1];
            newParams.set('sort_by', sortActualValue);
        }
    
        // 5. CONSTRUCT URL & REDIRECT
        // .toString() automatically handles the "?" and joins everything with "&"
        let finalUrl = baseUrl + (newParams.toString() ? "?" + newParams.toString() : "");
        
        window.location.href = finalUrl;
    });
});

